import { GripVertical, Trash2, ExternalLink } from 'lucide-react';
import { ScheduledActivityResponse } from '../../types/scheduledActivity';

interface DraggingActivityCardProps {
  scheduledActivity: ScheduledActivityResponse;
}

/**
 * Simplified version of ScheduledActivityCard for use in DragOverlay.
 * Renders the same visual appearance but without interactive functionality.
 */
export function DraggingActivityCard({
  scheduledActivity,
}: DraggingActivityCardProps) {
  return (
    <div className="p-2 bg-white rounded border border-gray-200 shadow-lg cursor-grabbing flex items-center gap-2">
      {/* Drag handle (visual only) */}
      <div
        className="p-1 text-gray-400"
        aria-hidden="true"
      >
        <GripVertical className="h-3 w-3" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium truncate">{scheduledActivity.activity.title}</p>
      </div>
      <div className="flex items-center gap-1 flex-shrink-0">
        {/* Visual placeholders for buttons - not interactive */}
        <div className="h-8 w-8 flex items-center justify-center opacity-50">
          <Trash2 className="h-4 w-4 text-red-600" />
        </div>
        <div className="h-8 w-8 flex items-center justify-center opacity-50">
          <ExternalLink className="h-4 w-4 text-gray-600" />
        </div>
      </div>
    </div>
  );
}
